/* eslint-disable @typescript-eslint/no-unsafe-call */
import sprite from "../assets/images/icons.svg?no-inline";

export const getTextEditorValue = (value, externalLinkIcon = true) => {
  let formattedValue = "";
  if (value?.document) {
    const documents = value.document;
    documents.forEach((document) => {
      if (document.type === "heading") {
        document.children.forEach((item) => {
          formattedValue += `<h${document.level}>${item.text}</h${
            document.level
          }>`;
        });
      } else {
        if (
          document.children &&
          document.children.length > 0 &&
          (document.children[0].text || document.children.length > 1)
        ) {
          formattedValue += "<p>";
          document.children.forEach((item) => {
            if (item.type) {
              if (item.type === "relationship") {
                formattedValue += ` <a class="link" href="/browse/${getRouteByKey(
                  item.relationship,
                )}/${item.data.id}">${item.data.label}</a> `;
              } else if (item.type === "link") {
                formattedValue += ` <a class="link" target="_blank" href="${
                  item.href
                }">${item.children[0].text}${
                  externalLinkIcon
                    ? `<svg style="color: #453a33;" width="15" height="15"><use xlinkHref="${
                        sprite
                      }#external" /></svg>`
                    : ""
                }</a>`;
              }
            } else if (item.text) {
              if (item.bold) {
                formattedValue += "<b>";
              }
              if (item.italic) {
                formattedValue += "<i>";
              }
              if (item.underline) {
                formattedValue += "<u>";
              }
              if (item.strikethrough) {
                formattedValue += "<s>";
              }
              formattedValue += item.text.replaceAll("\n", "<br>");
              if (item.strikethrough) {
                formattedValue += "</s>";
              }
              if (item.underline) {
                formattedValue += "</u>";
              }
              if (item.italic) {
                formattedValue += "</i>";
              }
              if (item.bold) {
                formattedValue += "</b>";
              }
            }
          });
          formattedValue += "</p>";
        }
      }
    });
  }
  return formattedValue;
};

export const getImageSrc = (value) => {
  let src = "";
  if (!value) return;
  if (value.images?.images?.length > 0) {
    src = value.images.images[0].bild.url;
  }
  if (value.imageObjects && value.imageObjects.length > 0) {
    if (value.imageObjects[0].images?.length > 0) {
      src = value.imageObjects[0].images[0].bild.url;
    }
  }
  if (value.images?.length > 0) {
    if (value.images[0].images) {
      src = value.images[0].images[0].bild.url;
    } else {
      src = value.images[0].bild.url;
    }
  }
  return src;
};

export const getRouteByKey = (key) => {
  switch (key.toLowerCase()) {
    case "ort":
      return "places";
    case "person":
      return "people";
    default:
      return "objects";
  }
};

export const getImages = (value, id) => {
  let images = "";
  if (value.images?.length > 0) {
    value.images.forEach((image) => {
      if (image.objekte[0]?.id !== id) {
        images += `<a class="link" href="/browse/${getRouteByKey(value.__typename)}/${
          image.objekte[0]?.id
        }">${image.objekte[0]?.title}</a>`;
      }
    });
  }
  if (value.length > 0) {
    value.forEach((imageOuter) => {
      if (imageOuter.images) {
        imageOuter.images.forEach((image) => {
          if (image.objekte[0]?.id !== id) {
            images += `<a class="link" href="/browse/${getRouteByKey(
              imageOuter.__typename,
            )}/${image.objekte[0]?.id}">${image.objekte[0]?.title}</a><br>`;
          }
        });
      } else {
        if (imageOuter.objekte[0]?.id !== id) {
          images += `<a class="link" href="/browse/${getRouteByKey(
            imageOuter.__typename,
          )}/${imageOuter.objekte[0]?.id}">${
            imageOuter.objekte[0]?.title
          }</a><br>`;
        }
      }
    });
  }
  return images;
};
